import { render, staticRenderFns } from "./AdminProfile.vue?vue&type=template&id=28984628&scoped=true&"
import script from "./AdminProfile.vue?vue&type=script&lang=ts&"
export * from "./AdminProfile.vue?vue&type=script&lang=ts&"
import style0 from "./AdminProfile.vue?vue&type=style&index=0&id=28984628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28984628",
  null
  
)

export default component.exports